// extracted by mini-css-extract-plugin
export default {"About4Main":"About4_About4Main__+wGxU","About4Parent":"About4_About4Parent__Sca0v","About4Child":"About4_About4Child__XUvxk","About4Child1":"About4_About4Child1__AEod9"};